// extracted by mini-css-extract-plugin
module.exports = {"pagination_container":"Pagination_pagination_container__1GiM8","pagination":"Pagination_pagination__3uRg9","currentPage":"Pagination_currentPage__16apy"};